import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export class HealthAspectPie extends AbstractChart {
    protected allChartOptions(): Options {
        return super.mergeOptions(
            super.allChartOptions(), {
                chart: {
                    type: 'pie',
                    plotBackgroundColor: null,
                    plotBorderWidth: 0,
                    plotShadow: false,
                    margin: 0,
                    height: 200,
                },
                title: {
                    useHTML: false,
                    widthAdjust: -20
                },
                subtitle: {
                    align: "center",
                    verticalAlign: "bottom",
                    y: -1
                },
                tooltip: {
                    enabled: true,
                    backgroundColor: 'white',
                    formatter: function () {
                        return `${this.series.name}<br>${this.percentage.toFixed(1)}%`;
                    }
                },
                plotOptions: {
                    pie: {
                        showInLegend: false,
                        startAngle: -90,
                        endAngle: 90,
                        borderWidth: 3,
                        marginTop: 0,
                        size: '100%',
                        center: ['50%', '100%'],
                        dataLabels: {
                            enabled: false,
                        },
                        states: {
                            hover: {
                                halo: null,
                            },
                        }
                    }
                }
            }
        );
    }
}

export default function () {
    registerPlugin(HealthAspectPie)
}
